// Video fallback if video isn't autoplaying
var videoWrapper = document.querySelector(".video__player video");
var fallbackImage = document.querySelector(".fallback-image");

if (videoWrapper?.currentTime > 0 != true) {
  //fallbackImage?.classList.add('visible');
}

/* Register ScrollTrigger */
// gsap.registerPlugin(ScrollTrigger)
// ScrollTrigger.config({
//   autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load, resize',
// })

// Accordion
const accordions = document.querySelectorAll('.accordion__item');
if (accordions.length > 0) {
  accordions.forEach(function (accordion) {
    accordion.addEventListener('click', function () {
      console.log('clicked')
      // Close all accordions
      accordions.forEach(function (item) {
        const content = item.querySelector('.accordion__content');
        if (item !== accordion && item.classList.contains('open')) {
          item.classList.remove('open');
          content.style.maxHeight = '0';
        }
      });

      // Toggle current accordion
      accordion.classList.toggle('open');
      const content = accordion.querySelector('.accordion__content');
      if (accordion.classList.contains('open')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = '0';
      }
    });
  });
}


// FAQs section image height
const accordionWrapper = document.querySelector('#faqs-section .copy-wrap');
const accordionImage = document.querySelector('.mcs-section-faq .aspectholder');

if (accordionImage != null) {
  accordionImage.style.height = accordionWrapper.offsetHeight + 'px';

  window.addEventListener('resize', () => {
    accordionImage.style.height = accordionWrapper.offsetHeight + 'px';
  });
}

// Swiper initialisations
var swiperAnnouncementBar = new Swiper('.swiper-announcement', {
  direction: 'horizontal',
  slidesPerView: 1.8,
  loop: true,
  spaceBetween: 100,
  freeMode: true,
  speed: 5000,
  autoplay: {
    delay: 0
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      speed: 8000,
    },
    1024: {
      slidesPerView: 5,
    }
  }
});

// custom scripts
$(document).ready(function () {
  // WINDOW SCROLLED
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 200) {
      $("body").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
    }
    if (scroll >= 20) {
      $("body").addClass("first-scrolled");
    } else {
      $("body").removeClass("first-scrolled");
    }
  });


  $(document).ready(function () {
    // Ingredients modal
    $("#openIngredientsModal").click(function() {
      $("#ingredientsModal").css("display", "block");
      $("body").css("overflow", "hidden");
    });

    $("#ingredientsClose").click(function() {
      $("#ingredientsModal").css("display", "none");
      $("body").css("overflow", "unset");
    });
  
    $(window).click(function(event) {
      if (event.target == $("#ingredientsModal")[0]) {
        $("#ingredientsModal").css("display", "none");
        $("body").css("overflow", "unset");
      }
    });

    // Dropdown ingredients
    $("#showIngredientsDropdown").click(function() {
      $("#ingredientsDropdown").toggleClass("active");

      if ($("#ingredientsDropdown").hasClass("active")) {
        $(this).text("Hide All");
      } else {
          $(this).text("View All");
      }
    });
    

    // Richtext Modal
    $("#openRichtextModal").click(function() {
      $("#richtextModal").css("display", "block");
      $("body").css("overflow", "hidden");
    });
  
    $("#richtextClose").click(function() {
      $("#richtextModal").css("display", "none");
      $("body").css("overflow", "unset");
    });
  
    $(window).click(function(event) {
      if (event.target == $("#richtextModal")[0]) {
        $("#richtextModal").css("display", "none");
        $("body").css("overflow", "unset");
      }
    });
    
    $('body').addClass('ready');
    setTimeout(function () {
      $('body').addClass('ready1');
    }, 1000);
    setTimeout(function () {
      $('body').addClass('ready2');
    }, 3000);

    $('.password-show').click(function () {
      $(this).removeClass('active');
      $('.password-field').addClass('active');
    });

    $('.subscribe-cta').click(function () {
      $(this).addClass('active');
      $('.splash-newsletter-wrapper').addClass('active');
    });

    $('.testimonial-slider').flickity({
      autoPlay: false,
      pauseAutoPlayOnHover: false,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      cellAlign: 'left'
    });

    $('.mcs-expands h6').click(function () {
      $(this).toggleClass('active');
      $(this).next('div').toggleClass('active');
    });

    $('#about').addClass('has-header-transparent has-first-section-overlay-header');
    $('#research-articles').addClass('has-header-transparent has-first-section-overlay-header');
    $('#contact').addClass('has-header-transparent has-first-section-overlay-header');

    // add visible to waypoints in viewport
    var viewport = $(window),
      setVisible = function (e) {
        var viewportTop = viewport.scrollTop() - 60, // add buffer to sotp area
          viewportBottom = viewport.scrollTop() + viewport.height() - 60;
        $('.waypoint').each(function () {
          var self = $(this),
            top = self.offset().top,
            bottom = top + self.height(),
            topOnScreen = top >= viewportTop && top <= viewportBottom,
            bottomOnScreen = bottom >= viewportTop && bottom <= viewportBottom,
            elemVisible = topOnScreen || bottomOnScreen;
          self.toggleClass('visible', elemVisible);
        });
      };
    viewport.scroll(setVisible);
    setVisible();

    // SCROLL TO FUNCTION
    $(function () {
      $('[data-toggle="elementscroll"]').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top - 130
            }, 600);
            return false;
          }
        }
      });
    });
  });

  $(window).on('load', function () {

    $('body').addClass('loaded');

    $('.splash-overlay').removeClass('active');

    $('.process-carousel').flickity({
      autoPlay: false,
      pauseAutoPlayOnHover: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: true,
      cellAlign: 'left'
    });

    $('.prod-carousel').flickity({
      autoPlay: false,
      pauseAutoPlayOnHover: false,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: true,
      cellAlign: 'left'
    });
  });
});


// Updating cart number
const cartDrawerCount = document.querySelector('.drawer__cart-count')

document.addEventListener('theme:cart:change', (event) => {
  if (event.detail && cartDrawerCount) {
    cartDrawerCount.textContent = event.detail.cartCount ?? 0; 
  }
});

// // ANNOUNCMENT BAR
const bodyWrapper = document.querySelector('body');
const announcementBar = document.querySelector('.announcement__bar-outer');

if (announcementBar != null) {
  bodyWrapper.classList.add('announcement-bar-visible');
}


// POPUP TRIGGER
const popup = document.querySelector('.popup-cookies[data-promo-text]');
const closePopup = document.querySelector('.popup-cookies[data-promo-text] .close');
const announcementBanner = document.querySelectorAll('.announcement__bar-holder.announcement__bar-holder--columns .announcement__section');

if (announcementBanner.length > 0) {
  const firstAnnouncement = announcementBanner[0];

  firstAnnouncement.addEventListener('click', () => {
    if (popup != null) {
      popup.style.opacity = '1';
      popup.style.display = 'block';
    }
  });


  if (popup != null ) {
    closePopup.addEventListener('click', () => {
      popup.style.opacity = '0';
      popup.style.display = 'none';
    })
  }
}